import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import InboxOutlinedIcon from "@mui/icons-material/InboxOutlined";

/**
 * Estado vacío: una lista o tabla sin registros. Tono calmado (no es un error).
 *
 * @param {object} props
 * @param {React.ReactNode} [props.icono] Elemento de ícono; por defecto una bandeja vacía.
 * @param {React.ReactNode} [props.titulo] Por defecto "No hay datos".
 * @param {React.ReactNode} [props.descripcion] Explica qué va aquí y cómo llenarlo.
 * @param {React.ReactNode} [props.accion] Botón para llenar el vacío (p. ej. "Nuevo cliente").
 */
export const EstadoVacio = ({
  icono,
  titulo = "No hay datos",
  descripcion,
  accion,
}) => (
  <Stack
    alignItems="center"
    textAlign="center"
    spacing={1.5}
    sx={{ py: 6, px: 2, color: "text.secondary" }}
  >
    <Box aria-hidden="true" sx={{ display: "flex", "& svg": { fontSize: 56 } }}>
      {icono ?? <InboxOutlinedIcon />}
    </Box>
    <Typography
      component="p"
      variant="h6"
      sx={{ fontWeight: 700, color: "text.secondary" }}
    >
      {titulo}
    </Typography>
    {descripcion && (
      <Typography
        variant="body2"
        sx={{ color: "text.secondary", maxWidth: 420 }}
      >
        {descripcion}
      </Typography>
    )}
    {accion && <Box sx={{ pt: 1 }}>{accion}</Box>}
  </Stack>
);
